import "font-awesome/css/font-awesome.min.css"
import React from "react"
import { Col } from "react-bootstrap"
import HeaderComponent from "./commonComponents/HeaderComponent"
import { useParams } from "react-router-dom"

function ServiceUnavailable(props) {
   sessionStorage.removeItem("breadCrumb")

  const { errorCode } = useParams()

   let errorMessage = ""

   switch (errorCode) {
      case "403": {
         errorMessage = "You do not have access to this object."
         break
      }

      case "404": {
         errorMessage = "Object is not available in Spec Reader Database."
         break
      }
      case "408": {
         errorMessage = "Request timed out, please try again!"
         break
      }
      case "409": {
         const encoded = sessionStorage.getItem("409ErrorMsg")
         errorMessage = encoded ? decodeURIComponent(atob(encoded)) : ""
         sessionStorage.removeItem("409ErrorMsg")
         break
      }
      case "422": {
         errorMessage =
            "You have exceeded the limit for the day and access to any additional Part/Specification is blocked! Please wait until the limit resets tomorrow or contact SpecReaderExt.im@pg.com and request the limit be reset."
         break
      }
      default: {
         errorMessage = "Integration service issue. Please contact SpecReaderExt.im@pg.com for help."
         break
      }
   }

   return (
      <React.Fragment>
         <HeaderComponent />
         <Col md={{ span: 10, offset: 1 }} className="searchTable">
            <span style={{ color: "white", textAlign: "center" }}>{errorMessage}</span>
         </Col>
      </React.Fragment>
   )
}
export default ServiceUnavailable
